import { createContext, useContext, useReducer } from 'react';
import { ACTION_TYPES, PublicationsReducer, PublicationsState } from './publications-reducer';
import { Pagination } from '../../../model/paginatiion';
import { IPublicationResponse } from '../../../model/base/response/publication-response';

const PublicationsContext = createContext<PublicationsState | undefined>(undefined);
const PublicationsContextDispatchContext = createContext({} as any);

const PublicationsProvider = ({ children }: { children: React.ReactNode }) => {
    const initialState: PublicationsState = {
        publications: new Pagination<IPublicationResponse>(),
        categories: [],
        subcategories: [],
        loading: false,
        loadingFilters: false,
    };

    const [state, dispatch] = useReducer(PublicationsReducer, initialState);

    return (
        <PublicationsContext.Provider value={state}>
            <PublicationsContextDispatchContext.Provider value={dispatch}>
                {children}
            </PublicationsContextDispatchContext.Provider>
        </PublicationsContext.Provider>
    );
}

const usePublicationsState = () => {
    const context = useContext(PublicationsContext);
    if (context === undefined) {
        throw new Error('usePublicationsState must be used within a PublicationsProvider');
    }
    return context;
}

const usePublicationsDispatch = () => {
    const context = useContext(PublicationsContextDispatchContext);
    if (context === undefined) {
        throw new Error('usePublicationsDispatch must be used within a PublicationsProvider');
    }
    return context;
}

export { PublicationsProvider, usePublicationsState, usePublicationsDispatch, ACTION_TYPES };
